import { Auth, Analytics } from "aws-amplify";
import Constants from "expo-constants";

const env = Constants.manifest.extra;

const amplifyConfig = {
  Auth: {
    identityPoolId: env?.PINPOINT_POOL_ID,
    region: env?.PINPOINT_REGION,
  },
};

const analyticsConfig = {
  AWSPinpoint: {
    appId: env?.PINPOINT_APP_ID,
    region: env?.PINPOINT_REGION,
    mandatorySignIn: false,
  },
};

export enum Event {
  NAVIGATE = "Navigate",
  CRASHED = "Crashed",
}

export default function configure() {
  //Initialize Amplify
  Auth.configure(amplifyConfig);
  Analytics.configure(analyticsConfig);
}

export interface Props {
  eventName: string;
  attributes?: { [n: string]: string };
  metrics?: { [n: string]: number };
}
export function recordEvent(props: Props) {
  //Record an event
  try {
    if (!__DEV__) Analytics.record({ name: props.eventName, attributes: props.attributes, metrics: props.metrics });
  } catch (error) {
    console.warn(error);
  }
}
